<!-- Layout with one column used for NON nested pages such as Applications, Authentications etc -->
<template>
  <v-app id="inspire">
    <Header />
    <v-main class="grey lighten-3">
      <v-container>
        <v-sheet min-height="calc(100vh - 160px)" min-width="100%" rounded="lg">
          <router-view />
          <div class="pb-2 d-flex border-top">
            <v-spacer></v-spacer>
            <span class="grey--text">Laatst opgehaald op:</span>
            <span class="mx-2 grey--text">{{
              new Date().toLocaleString("nl-NL")
            }}</span>
          </div>
        </v-sheet>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
export default {
  components: {
    Header,
  }
};
</script>

<style lang="scss" scoped>
.border-top {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}
</style>